import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import "./SignUp.css";
import { Link, useNavigate } from "react-router-dom";
import ai_powered_cv_logo from "../../../assets/img/Ai-powered-cv-logo.png";
// Validation Schema
const BASE_URL = process.env.REACT_APP_BASE_URL;
const validationSchema = Yup.object({
  name: Yup.string()
    .min(3, "Name should be at least 3 characters")
    .required("Name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password should be at least 6 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
  terms: Yup.boolean().oneOf(
    [true],
    "You must accept the terms and conditions"
  ),
});

function SignUp() {
  const navigate = useNavigate();
  const notifySuccess = () => toast.success("Registration Successful");

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      terms: false,
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true);
      try {
        await axios.post(
          `${BASE_URL}/api/users/register`,
          {
            name: values.name,
            email: values.email,
            password: values.password,
            confirmPassword: values.confirmPassword,
          }
        );
        notifySuccess();
        setTimeout(() => navigate("/login"), 1000);
        resetForm();
      } catch (error) {
        toast.error(error.response?.data?.message || "Registration failed");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="signup-container">
      <Container className="d-flex flex-column align-items-center justify-content-center ">
        <h1 className="mb-4 ">
          <Link to="/" className="text-decoration-none d-flex justify-content-center me-3 ">
            <img 
              src={ ai_powered_cv_logo}
              alt="AI-Powered CV" 
              className="logo-img w-50"
            />
          </Link>
        </h1>

        <Row className="justify-content-center w-100">
          <Col md={6} lg={5}>
            <Card className="p-4 glassmorphism">
              <Card.Body>
                <h2 className="text-center text-white mb-4">
                  Create an Account
                </h2>
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      {...formik.getFieldProps("name")}
                      isInvalid={formik.touched.name && formik.errors.name}
                      className="p-2"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Your Email"
                      {...formik.getFieldProps("email")}
                      isInvalid={formik.touched.email && formik.errors.email}
                      className="p-2"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Password"
                      {...formik.getFieldProps("password")}
                      isInvalid={
                        formik.touched.password && formik.errors.password
                      }
                      className="p-2"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="password"
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      {...formik.getFieldProps("confirmPassword")}
                      isInvalid={
                        formik.touched.confirmPassword &&
                        formik.errors.confirmPassword
                      }
                      className="p-2"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.confirmPassword}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Check
                    type="checkbox"
                    name="terms"
                    label="I agree to the terms of service"
                    {...formik.getFieldProps("terms")}
                    isInvalid={formik.touched.terms && formik.errors.terms}
                    className="text-white"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.terms}
                  </Form.Control.Feedback>

                  <Button
                    type="submit"
                    className="mt-3 w-100 btn-custom"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Register"
                    )}
                  </Button>
                </Form>

                <p className="text-center text-white mt-3">
                  Already have an account?{" "}
                  <Link to="/login" className="text-primary fw-bold">
                    Login here
                  </Link>
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <ToastContainer />
    </div>
  );
}

export default SignUp;
